import { Popover } from "@mui/material";
import { css, styled } from "@mui/material/styles";

export const StyledPopover = styled(Popover)`
  .MuiPaper-root {
    ${({ theme }) => css`
      background-color: ${theme.wsc.palette.neutral[800]};
      border: 1px solid ${theme.wsc.palette.neutral[500]};
      border-radius: ${theme.wsc.radius.m};
      color: ${theme.wsc.palette.neutral[100]};
      padding: ${theme.wsc.spacing[2]};
    `}
  }
`;
